import React, { useState, useEffect } from "react";
import { ThemeProvider, createTheme, CssBaseline } from "@mui/material";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import BottomNav from "./Components/BottomNav";
import Start from "./Global/Start";
import Profile from "./Profile/Profile";
import Login from "./Login/Login";
import Registration from "./Login/Registration";
import Arenamap from "./Profile/Arenamap";
import Pokedex from "./Profile/Pokedex";
import About from "./Global/About";
import Settings from "./Profile/Settings";
import Members from "./Global/Members";
import Trainercodes from "./Global/Friendcodes";
import ProfileExtern from "./Extern/ProfileExtern";
import ProfileMedals from "./Profile/ProfileMedals";
import ProfileMedalsExtern from "./Extern/ProfileMedalsExtern";
import ArenamapExtern from "./Extern/ArenamapExtern";
import ForgotPassword from "./Login/ForgotPassword";

const getTheme = (mode) =>
  createTheme({
    palette: {
      mode,
      primary: {
        main: "#CC0000",
        light: "#ff4444",
        dark: "#990000",
        contrastText: "#ffffff",
      },
      secondary: {
        main: "#3F51B5",
        contrastText: "#ffffff",
      },
      success: { main: "#2E7D32" },
      ...(mode === "dark"
        ? {
            background: {
              default: "#0f0f0f",
              paper: "#1e1e1e",
            },
          }
        : {
            background: {
              default: "#f4f4f8",
              paper: "#ffffff",
            },
          }),
    },
    shape: { borderRadius: 12 },
    typography: {
      h4: { fontWeight: 700 },
      h5: { fontWeight: 600 },
      h6: { fontWeight: 600 },
      button: { textTransform: "none", fontWeight: 600 },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: { borderRadius: 10, padding: "10px 20px" },
          sizeLarge: { padding: "13px 28px", fontSize: "1rem" },
        },
      },
      MuiPaper: {
        styleOverrides: { root: { borderRadius: 16 } },
      },
      MuiCard: {
        styleOverrides: { root: { borderRadius: 16 } },
      },
      MuiChip: {
        styleOverrides: { root: { borderRadius: 8 } },
      },
      MuiBottomNavigation: {
        styleOverrides: { root: { backgroundColor: "transparent" } },
      },
    },
  });

const AppContent = ({ themeMode, toggleTheme }) => {
  const location = useLocation();
  const hideNavOnRoutes = ["/arenamap", "/Extern/ArenamapExtern"];
  const shouldHideNav = hideNavOnRoutes.some((route) =>
    location.pathname.startsWith(route)
  );

  return (
    <>
      {!shouldHideNav && (
        <BottomNav toggleTheme={toggleTheme} themeMode={themeMode} />
      )}
      <Routes>
        <Route path="/" element={<Start />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/profile/:id" element={<ProfileExtern />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/registration" element={<Registration />} />
        <Route path="/pokedex" element={<Pokedex />} />
        <Route path="/arenamap" element={<Arenamap />} />
        <Route path="/about" element={<About />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/members" element={<Members />} />
        <Route path="/trainercodes" element={<Trainercodes />} />
        <Route path="/medals" element={<ProfileMedals />} />
        <Route path="/ProfileMedals/:id" element={<ProfileMedalsExtern />} />
        <Route path="/Extern/ArenamapExtern/:id" element={<ArenamapExtern />} />
      </Routes>
    </>
  );
};

const App = () => {
  const [themeMode, setThemeMode] = useState("light");

  useEffect(() => {
    const savedMode = localStorage.getItem("themeMode") || "light";
    setThemeMode(savedMode);
  }, []);

  const toggleTheme = () => {
    const newMode = themeMode === "light" ? "dark" : "light";
    setThemeMode(newMode);
    localStorage.setItem("themeMode", newMode);
  };

  return (
    <ThemeProvider theme={getTheme(themeMode)}>
      <CssBaseline />
      <Router>
        <AppContent themeMode={themeMode} toggleTheme={toggleTheme} />
      </Router>
    </ThemeProvider>
  );
};

export default App;
